/* selv-card.js · Selv v6, lot COLLECTIONS · vanilla, sans bibliothèque.
   Chargé en module (type="module", donc différé) par la 1re carte lq-card d'une liste, ou par les gabarits de
   collection et de recherche : un module n'est exécuté qu'une fois par page, même lié par plusieurs listes.
   1. 2e image des cartes : rendue sans src ni srcset (data-srcset, data-sizes). Chargée au 1er survol de la carte
      (souris), au 1er toucher ou défilement de sa piste (doigt, grilles seulement), ou, après l'événement load et en
      temps libre, pour les seules cartes de grille visibles à ce moment. Jamais dans un rail au doigt (piste figée).
      La carte reçoit is-alt-ready quand l'image est prête : le survol ne montre jamais une diapositive vide.
   2. Ajout rapide « + » : /cart/add.js, coche sur le bouton, goutte versée vers l'icône du panier (SelvLiquid.drop)
      et message « Ajouté à ton panier » (SelvLiquid.toast), sans ouvrir le tiroir. Le tiroir et le compteur sont
      rafraîchis par les événements de Flow (update:cart:drawer, cart:added). Erreur : message de Shopify.
      Sans ce fichier, selv-liquid.js (lot DESIGN) garde la main ; sans JS, le formulaire mène à la fiche.
   3. Code de campagne déjà appliqué (témoin discount_code) : repli de la classe html.lq-deal-on pour les cartes
      insérées après coup (recherche prédictive, « Afficher plus »), déjà posée par le script en ligne des sections. */
const d = document;
const root = d.documentElement;
root.classList.add('lq-cards-on');

/* 0. Une seule feuille et un seul script de carte par page (point R2) ------------------------------ */
/* Chaque liste insère selv-card.css et ce module au-dessus de sa 1re carte ; l'accueil, la fiche, l'article ou le panier
   en reçoivent donc plusieurs copies (et l'en-tête une copie sans blocage hors des gabarits à cartes). On garde la 1re
   copie appliquée et on retire les autres : même URL, même contenu, aucun changement visible. Une copie encore en
   chargement est revue à son chargement (son propre gestionnaire onload fait la même chose). Les copies du script sont
   retirées sans risque : ce module est déjà exécuté, et un module n'est exécuté qu'une fois par page. */
const dedupeAssets = () => {
  const links = [...d.querySelectorAll('link[rel="stylesheet"][href*="selv-card.css"]')];
  const keep = links.find((l) => l.sheet && l.media !== 'print');
  links.forEach((l) => {
    if (l === keep) return;
    if (keep && l.sheet && l.media !== 'print') l.remove();
    else if (!l.sheet || l.media === 'print') l.addEventListener('load', dedupeAssets, { once: true });
  });
  d.querySelectorAll('script[src*="selv-card.js"]').forEach((s, i) => { if (i) s.remove(); });
};
dedupeAssets();

/* 1. 2e image ------------------------------------------------------------------------------------ */
const ALT = 'img[data-srcset]';
const loadAlt = (card) => {
  if (!card) return;
  const img = card.querySelector(ALT);
  if (!img) return;
  const ready = () => card.classList.add('is-alt-ready');
  img.addEventListener('load', ready, { once: true });
  if (img.dataset.sizes) img.sizes = img.dataset.sizes;
  img.srcset = img.dataset.srcset;
  img.removeAttribute('data-srcset');
  img.removeAttribute('data-sizes');
  if (img.complete && img.naturalWidth) ready();
};
const cardOf = (t) => (t && t.closest ? t.closest('.lq-card.has-alt') : null);
d.addEventListener('pointerover', (e) => {
  if (e.pointerType !== 'mouse') return;
  const card = cardOf(e.target);
  if (card && card.querySelector(ALT)) loadAlt(card);
}, { passive: true });
const inGrid = (card) => !!(card && card.closest('.lq-coll-grid'));
d.addEventListener('touchstart', (e) => {
  const card = cardOf(e.target);
  if (card && inGrid(card) && e.target.closest('.lq-card__track') && card.querySelector(ALT)) loadAlt(card);
}, { passive: true });
d.addEventListener('scroll', (e) => {
  const t = e.target;
  if (t && t.classList && t.classList.contains('lq-card__track')) loadAlt(cardOf(t));
}, { capture: true, passive: true });
const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
// Cartes de grille visibles à ce moment : lues par un IntersectionObserver (réponse livrée après la mise en page, par
// lots), jamais par getBoundingClientRect sur toutes les cartes (mise en page forcée, tâche longue au téléphone).
const warmVisible = () => idle(() => {
  const cards = [...d.querySelectorAll('.lq-coll-grid .lq-card.has-alt')].filter((c) => c.querySelector(ALT));
  if (!cards.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    io.disconnect();
    entries.forEach((en) => { if (en.isIntersecting) loadAlt(en.target); });
  });
  cards.forEach((c) => io.observe(c));
}, { timeout: 4000 });
if (d.readyState === 'complete') warmVisible();
else window.addEventListener('load', warmVisible, { once: true });

/* 3. Code déjà appliqué -------------------------------------------------------------------------- */
const cookieCodes = (() => {
  const m = d.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
  if (!m) return [];
  try { return decodeURIComponent(m[1]).toUpperCase().split(',').map((s) => s.trim()); } catch (err) { return []; }
})();

/* 2. Ajout rapide -------------------------------------------------------------------------------- */
const TXT = (() => {
  const en = /^en/i.test(root.lang || '');
  const t = {
    added: en ? 'Added to your cart' : 'Ajouté à ton panier',
    addError: en ? 'Something went wrong. Please try again in a moment.' : 'L’ajout n’a pas fonctionné. Réessaie dans un instant.',
  };
  try {
    const el = d.getElementById('SelvCartText');
    if (el && !en) {
      const j = JSON.parse(el.textContent);
      if (j.added) t.added = j.added;
      if (j.addError) t.addError = j.addError;
    }
  } catch (err) { /* textes par défaut */ }
  return t;
})();
const toast = (msg, opts) => {
  const L = window.SelvLiquid;
  if (L && typeof L.toast === 'function') L.toast(msg, opts || {});
};
const quickAdd = (e, form, btn) => {
  if (!form || typeof window.fetch !== 'function' || !window.FormData) return;
  if (form.closest('[data-selv-cart-page]')) return; // page panier : le lot PANIER garde la main
  // Les écouteurs de selv-liquid.js (qui ouvrent le tiroir) sont sur le document, en phase de remontée :
  // on les devance en phase de capture et on arrête l'événement.
  e.preventDefault();
  e.stopPropagation();
  if (!btn || btn.getAttribute('aria-busy') === 'true') return;
  btn.setAttribute('aria-busy', 'true');
  btn.classList.remove('is-added');
  const data = new FormData(form);
  data.append('sections', 'cart-drawer');
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(`${base}cart/add.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
    .then((r) => r.json().catch(() => ({ status: r.status })).then((res) => {
      if (!r.ok || (res && res.status && res.status !== 200)) {
        const err = new Error((res && (res.description || res.message)) || '');
        err.res = res;
        throw err;
      }
      return res;
    }))
    .then((res) => {
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1600);
      const L = window.SelvLiquid;
      if (L && typeof L.drop === 'function') { try { L.drop(btn); } catch (err) { /* animation facultative */ } }
      const bus = window.eventBus;
      if (bus && typeof bus.emit === 'function') {
        bus.emit('update:cart:drawer', res);
        bus.emit('cart:added', res);
      }
      toast(TXT.added);
    })
    .catch((err) => {
      // Message de Shopify (ex. quantité indisponible) s'il y en a un ; sinon le texte de la maison.
      toast((err && err.res && err.message) || TXT.addError, { error: true, duration: 5200 });
    })
    .finally(() => btn.removeAttribute('aria-busy'));
};
d.addEventListener('click', (e) => {
  const btn = e.target && e.target.closest ? e.target.closest('form.lq-card__quick button') : null;
  if (!btn || (btn.type && btn.type !== 'submit') || e.defaultPrevented) return;
  quickAdd(e, btn.form || btn.closest('form'), btn);
}, true);
d.addEventListener('submit', (e) => {
  const form = e.target && e.target.closest ? e.target.closest('form.lq-card__quick') : null;
  if (!form || e.defaultPrevented) return;
  quickAdd(e, form, form.querySelector('button'));
}, true);

/* 3 bis. Repli de la classe lq-deal-on (cartes insérées après coup) ------------------------------- */
if (cookieCodes.length && !root.classList.contains('lq-deal-on')) {
  const holder = d.querySelector('[data-lq-deal-code]');
  const code = holder ? (holder.getAttribute('data-lq-deal-code') || '').toUpperCase() : '';
  if (code && cookieCodes.indexOf(code) > -1) root.classList.add('lq-deal-on');
}
